exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header{background-color:#fff;border-bottom:none;padding:15px 15px 5px}.card-header .nav-tabs .nav-item{text-transform:uppercase;border-right:1px solid #ddd;height:20px;margin-bottom:20px;font-size:11px}.card-header .nav-tabs .nav-item a{color:#000;margin-top:-10px}.card-header .nav-tabs .nav-link.active{border:none;background-color:#fff;font-weight:700}.card-header .nav-tabs .nav-link.active .tab-title{border-bottom:3px solid #f4812e!important}.card-header .nav-link.active:after{display:inline-block}.card-header .nav-tabs .nav-link:hover{border:none}.card-header .nav-item:nth-child(4){border-left:none!important;padding-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b8aa8f5","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Registration.vue
// module id = 691N
// module chunks = 36